class HeaderContainer {
  constructor($location, appEvents, appSession, appSessionCapabilities, APP_EVENTS) {
    'ngInject';

    this.$location = $location;
    this.appEvents = appEvents;
    this.appSession = appSession;
    this.appSessionCapabilities = appSessionCapabilities;
    this.APP_EVENTS = APP_EVENTS;

    this.showHeader = false;
    this.sessionChangeSubscription = () => {};
    this.accountName = '';
    this.popoverActionsTypes = {
      settings: {
        id: 'settings',
        label: 'Settings',
      },
    };
    this.popoverOptions = [
      this.popoverActionsTypes.settings,
      {
        url: '/logout',
        label: 'Logout',
      },
    ];
    this.actionsTypes = {
      createUser: {
        id: 'create-user',
        label: 'Create user',
      },
    };
    this.actions = [];
  }
  $onInit() {
    this.sessionChangeSubscription = this.appSession.onSessionChange(() => this.updateUI());
    this.updateUI();
  }
  $onDestroy() {
    this.sessionChangeSubscription();
  }
  updateUI() {
    this.showHeader = this.appSession.isAuthenticated();
    this.actions = [];
    if (this.showHeader) {
      this.accountName = this.appSession.getSession().user.name;
      if (this.appSessionCapabilities.canCreateUser()) {
        this.actions.push(this.actionsTypes.createUser);
      }
    }
  }
  handlePopoverAction(action) {
    switch (action.id) {
    case this.popoverActionsTypes.settings.id:
      this.openSettingsModal();
      break;
    default:
    }
  }
  handleAction(action) {
    switch (action.id) {
    case this.actionsTypes.createUser.id:
      this.openCreateUserModal();
      break;
    default:
    }
  }
  openCreateUserModal() {
    this.appEvents.emit(this.APP_EVENTS.createUser.open);
  }
  openSettingsModal() {
    this.appEvents.emit(this.APP_EVENTS.settings.open);
  }
}

export default {
  controller: HeaderContainer,
  template: `
    <header
      ng-if="$ctrl.showHeader"
      account-name="$ctrl.accountName"
      popover-options="$ctrl.popoverOptions"
      on-popover-action-clicked="$ctrl.handlePopoverAction(action)"
      actions="$ctrl.actions"
      on-action-clicked="$ctrl.handleAction(action)"
    ></header>
  `,
};
